import React from "react";
import './styles.css'
import { AnswerKeyType } from "../../utils/interface/answer";
import GenericAnswer from "./sections/generic";
import Logo from "../../assets/logo.webp";

interface ExamPaperProps {
    data: AnswerKeyType;
}

export default function AnswerKey(props: ExamPaperProps) {

    const { data } = props;


    return (
        <div className="exam_paper">
            <div className="exam_wrapper">


                {/* HEADER */}
                <div className="exam_header">
                    <img
                        src={Logo}
                        alt="Chanakya Logo"
                        className="exam_header__logo"
                    />
                    <h2>{data.assessment_title}</h2>
                    <h2>Class - {data.class}</h2>
                    <h2>Subject : {data.subject}</h2>
                </div>

                {/* SECTIONS */}
                {
                    data.sections.map((section, index) => (
                        <div className="exam_section answer_key" key={index}>
                            <h2 className="section_title">{section.name}</h2>
                            <span className="section_description">{section.description}</span>
                            <div className="section_question_holder">
                                {
                                    section.questions.map((question, index) => (
                                        <GenericAnswer
                                            key={index}
                                            question={question}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }


                <span className="branding">AI Exam by <a target='_blank' href="https://aichanakya.in/" rel="noreferrer">Chanakya AI Assessments</a></span>

            </div>
        </div>
    )
}